import axios from "axios";
import React, {Component} from "react";
import Modal from "react-bootstrap/Modal";
import FeatherIcon from 'feather-icons-react';
import Select from 'react-select';
import { toast } from "react-toastify";

class   EvaluationForm extends Component{

    state = {
        id : null,
        scheduleId : "",
        reason_evaluation : null,
        max : null,
        error : "",
        
        isModal : false,
        title : null,

        schedules : [],
    }

    handleInput = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        }); 
    }

    async getSchedules () {
        var id = this.props.sectionclasse ? this.props.sectionclasse?.id : "--";
        var request = await axios.get("schedules/sectionclasse/" + id);
        if(request.status == 200)
        {
            this.setState({
                schedules : request.data
            })
        }
    }

    storeEvaluation = () =>{
        var data = {
                scheduleId : this.state.scheduleId,
                reason_evaluation : this.state.reason_evaluation,
                max : this.state.max > 0 ? this.state.max : null,
                operation : this.state.id ? "Editer" : "Ajouter",
            }
            
        var request = this.state.id ? axios.put('evaluations/'+this.state.id, data) : axios.post('evaluations', data);
        request.then((response) =>{
            this.props.showModal(response.data.data?.id)
            toast(response?.data?.msg, { theme : "light", style : { backgroundColor : "blue", color : "white"}})
        }).catch((error) => {
            this.setState({
                error : error.response.data.error
            })
            toast(error.response?.data?.msg, { theme : "light", style : { backgroundColor : "red", color : "white"}})
        })
    }
    
    edit=()=>  {
        this.form()
        this.getSchedules()
    }

    form=()=>{ 
        this.setState({
            id: this.props.formData ? this.props.formData.id : "",
            scheduleId: this.props.formData ? this.props.formData.scheduleId  : "",
            reason_evaluation: this.props.formData ? this.props.formData.reason_evaluation : "",
            max: this.props.formData ? this.props.formData.max : null,
            title : this.props.formData ? "Modifier la planification de l'evaluation" : "Planifier une evaluation",
            error : "",
        })
    }

    showModal = () => {
        this.setState({
            isModal : !this.state.isModal,
        })
    }

  handleCheck(val) {
    var permissions = localStorage.getItem("permissions") ? JSON.parse(localStorage.getItem("permissions")) : [];
     return  permissions.some(item => val === item.permission);
 }
    
    render(){
        var user = JSON.parse(localStorage.getItem("user"))
        var schedules = [], date_start = "", count = [];
        var editing = Boolean(this.state.id);

        this.state.schedules.filter(examen => examen.periodeId != 3 && examen.periodeId != 6 && examen.periodeId != 7 ).map((schedule) =>{
            date_start = "";
            if(schedule.time_start)
                date_start = date_start + " " + schedule.time_start +" - "
            if(schedule.time_end)
                date_start = date_start + " " + schedule.time_end

            if(this.state.scheduleId || this.props.sectionclasse && this.props.sectionclasse.id == schedule.sectionclasselesson.sectionclass.id)
            {
                if(schedule.sectionclasselesson.staff?.user?.id == user?.id || this.handleCheck("Profil admin") == true)
                {
                    if(count.filter(item => item.periode  == schedule.periodeId && item.lesson == schedule.sectionclasselesson.lesson.id ).length == 0)
                    {
                        count.push({
                            lesson : schedule.sectionclasselesson.lesson.id,
                            periode : schedule.periodeId
                        })
                        schedules.push({ value : schedule.id, label : schedule.sectionclasselesson.lesson.entitled_lesson + " #"+ schedule.periodeId+ "P# " + date_start })
                    }
                }
            }
        })

        return(
            <Modal
                show={this.props.isModal}
                onHide={this.props.showModal}
                size="lg"
                centered
                onEntered={this.edit}
                backdrop={"static"}
                dialogClassName="sectionclasse-form">
                <Modal.Header className="sectionclasse-form__header">
                    <div className="sectionclasse-form__title">
                        <span><FeatherIcon icon={editing ? "edit-3" : "clipboard"} size={20} /></span>
                        <div>
                            <small>Planification des évaluations</small>
                            <Modal.Title>
                                {this.state.title} { this.props.sectionclasse ? this.props.sectionclasse?.class?.short_entitled_class + " " + (this.props.sectionclasse?.title || '') +" " + this.props.sectionclasse?.section?.short_entitled_section   : "" }
                            </Modal.Title>
                        </div>
                    </div>
                    <button type="button" className="sectionclasse-form__close" onClick={this.props.showModal} aria-label="Fermer">
                        <FeatherIcon icon="x" size={18} />
                    </button>
                </Modal.Header>
                <Modal.Body className="sectionclasse-form__body">
                    <p className="sectionclasse-form__intro">
                        Définissez l’horaire, le motif et la note maximale de l’évaluation pour cette classe.
                    </p>

                    {this.state.error ? (
                        <div className="sectionclasse-form__alert" role="alert">
                            <FeatherIcon icon="alert-circle" size={16} />
                            {this.state.error}
                        </div>
                    ) : null}

                    <div className="row g-3">
                        <div className="col-12">
                            <label className="sectionclasse-field__label" htmlFor="evaluation-schedule">
                                <FeatherIcon icon="calendar" size={15} />
                                Horaire de l'évaluation <b>*</b>
                            </label>
                            <Select
                                inputId="evaluation-schedule"
                                classNamePrefix="sectionclasse-select"
                                placeholder="Choisir un horaire"
                                value={schedules.filter(option => option.value == this.state.scheduleId)}
                                onChange={(select) => {
                                    this.setState({
                                        scheduleId : select?.value || "",
                                        error : "",
                                    });
                                }}
                                options={schedules.sort((a, b) => (a.label > b.label ? 1 : -1))}
                                noOptionsMessage={() => "Aucun horaire disponible"}
                                menuPortalTarget={typeof document !== "undefined" ? document.body : null}
                                menuPosition="fixed"
                                styles={{ menuPortal: (base) => ({ ...base, zIndex: 1060 }) }}
                            />
                        </div>

                        <div className="col-md-6">
                            <label className="sectionclasse-field__label" htmlFor="evaluation-reason">
                                <FeatherIcon icon="trello" size={15} />
                                Motif d'évaluation
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Motif d'évaluation"
                                onChange={this.handleInput}
                                name="reason_evaluation"
                                value={this.state.reason_evaluation}
                                id="evaluation-reason"
                            />
                        </div>

                        <div className="col-md-6">
                            <label className="sectionclasse-field__label" htmlFor="evaluation-max">
                                <FeatherIcon icon="box" size={15} />
                                Max
                            </label>
                            <input
                                type="number"
                                className="form-control"
                                placeholder="Max"
                                onChange={this.handleInput}
                                name="max"
                                value={this.state.max}
                                id="evaluation-max"
                            />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="sectionclasse-form__footer">
                    <button type="button" onClick={this.props.showModal} className="sectionclasse-form__button btn btn-light">
                        <FeatherIcon icon="corner-down-left" size={15} /> Fermer
                    </button>
                    {
                        this.handleCheck("Ajouter evaluation") == true || this.handleCheck("Modifier evaluation") == true ? (
                            <button type="button" onClick={() => this.storeEvaluation()} className="sectionclasse-form__button btn btn-primary">
                                <FeatherIcon icon="check-square" size={15} /> Sauvegarder
                            </button>
                        ) : ""
                    }
                </Modal.Footer>
            </Modal>
        )
    }
}
export default EvaluationForm;